import React from 'react';

type MembershipPanelShellProps = {
  title?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
};

const MembershipPanelShell: React.FC<MembershipPanelShellProps> = ({
  title,
  actions,
  children,
}) => {
  const showHeader = Boolean(title || actions);
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
      {showHeader ? (
        <div className="shrink-0 border-b border-gray-200 bg-white px-4 py-3 dark:border-gray-700 dark:bg-gray-900 sm:px-6">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            {title ? (
              <h2 className="text-lg font-semibold text-gray-900 dark:text-white">{title}</h2>
            ) : (
              <span />
            )}
            {actions ? <div className="flex shrink-0 flex-wrap gap-2">{actions}</div> : null}
          </div>
        </div>
      ) : null}
      <div className="min-h-0 flex-1 overflow-y-auto p-4 sm:p-6">{children}</div>
    </div>
  );
};

export default MembershipPanelShell;
